export var BODY_GRID_PADDING = 4;
export var SMALL_GRID_SPACE = 2;
export var NORMAL_GRID_SPACE = 3;
